function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrolltop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "65px",
    height: "32px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#ffffff",
    d: "M 27.5,-0.5 C 30.5,-0.5 33.5,-0.5 36.5,-0.5C 45.8068,8.47245 55.1401,17.4725 64.5,26.5C 64.5,27.8333 64.5,29.1667 64.5,30.5C 63.8333,30.5 63.5,30.8333 63.5,31.5C 61.8333,31.5 60.1667,31.5 58.5,31.5C 50.1595,22.3261 41.3261,13.6594 32,5.5C 22.043,13.2892 12.8764,21.9558 4.5,31.5C 2.83333,31.5 1.16667,31.5 -0.5,31.5C -0.5,29.8333 -0.5,28.1667 -0.5,26.5C 8.8599,17.4725 18.1932,8.47245 27.5,-0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolltop);
export default __webpack_public_path__ + "static/media/scrolltop.f4bed2d414eabc53aba74c94ad83501d.svg";
export { ForwardRef as ReactComponent };